import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { take } from 'rxjs/operators';

import { AuthenticationSandbox } from '../sandbox/authentication.sandbox';

@Injectable({ providedIn: 'root' })
export class UseOauthGuard {
    // Application will get stuck if oauth redirects to one of these
    private readonly entryNavBlackList: string[] = ['token', 'auth/redirect', 'logout'];
    constructor(private readonly sandbox: AuthenticationSandbox) {}

    canActivate(route: ActivatedRouteSnapshot): boolean {
        // Navigate further to Login component for offline mode,
        // Else use configured OAuth
        if (this.sandbox.isOfflineEnvironment()) {
            return true;
        } else {
            const entryNavigationUrl: string | null = route.queryParamMap.get('entryNavigationUrl');
            const safeUrl: string =
                !!entryNavigationUrl && !this.entryNavBlackList.includes(entryNavigationUrl) ? entryNavigationUrl : '/';
            this.navigateToOauthFlow(safeUrl);
            return false;
        }
    }

    navigateToOauthFlow(entryNavigationUrl: string): void {
        this.sandbox
            .getNewStatefulOauthUrl(entryNavigationUrl)
            .pipe(take(1))
            .subscribe(oauthUrl => {
                window.location.href = oauthUrl;
            });
    }
}
